<template>
  <VpVueForm
    :fields="fields"
    :id="cardId"
    class="vp-p-6"
    :save="save"
    :get="get"
    #default="{ state, response }"
    width="400px"
    feature="CARDS"
  >
    <VpField rules="required" label="Title" name="title">
      <VpInput>
        <VpTextBox v-model="state.name" />
      </VpInput>
    </VpField>

    <VpField optional label="Description">
      <VpTextArea v-model="state.desc" :rows="5" />
    </VpField>

    <VpField
      :rules="{
        required: true,
        min: 5,
        subdomain: true,
      }"
      label="Card Link"
      name="Card Link"
      note="People can see your card by visiting this link. Old link will stop working if you change this."
    >
      <VpInput after=".vepaar.cards">
        <VpTextBox v-model="state.subdomain" />
      </VpInput>
    </VpField>

    <VpField
      label="Card Permanent Link"
      note="This link is not editable and remains same even if you change the link above. You can use this link for QR codes & NFC Cards."
    >
      <a :href="response.url" target="_blank" class="vp-text-primary-500">{{
        response.url
      }}</a>
    </VpField>

    <VpField label="Profile Image">
      <VpImageEditor
        id="PROFILE"
        crop
        :crop-ratio="1 / 1"
        v-model="profilePicture"
        #default="{ value }"
      >
        <VpMedia type="Image" size="96" :value="value" />
      </VpImageEditor>
    </VpField>

    <VpField label="Cover Image">
      <VpImageEditor
        id="COVER"
        v-model="cover"
        crop
        :crop-ratio="16 / 9"
        #default="{ value }"
      >
        <div class="vp-w-64">
          <VpMedia type="Image" size="16x9" :value="value" />
        </div>
      </VpImageEditor>
    </VpField>
  </VpVueForm>
</template>

<script>
import get from "./get.gql";
import upsert from "./upsert.gql";
import { uploadMediaToS3 } from "utils/presets";

export default {
  props: {
    cardId: [String, Number],
  },
  data() {
    return {
      profilePicture: null,
      cover: null,
      fields: [
        "coverId",
        "profilePictureId",
        "name",
        "subdomain",
        "desc",
        "url",
      ],
    };
  },

  methods: {
    get(id) {
      return this.$query(get, {
        id: Number(id),
      }).then(({ data }) => {
        const { profilePicture, cover, name, desc, subdomain } = data.card;

        this.profilePicture = {
          url: profilePicture?.url,
        };

        this.cover = {
          url: cover?.url,
        };

        return {
          values: {
            name,
            desc,
            subdomain,
            coverId: cover?.id,
            profilePictureId: profilePicture?.id,
          },
          res: data,
        };
      });
    },

    async save(id, data) {
      if (this.profilePicture.status == "CHANGE") {
        const profileUploadData = {
          path: "card_profile_picture",
          file: this.profilePicture,
        };
        const uploadedMedia = await uploadMediaToS3(profileUploadData);
        this.profilePicture.status = null;
        data.profilePictureId = uploadedMedia.id;
      } else if (this.profilePicture.status == "DELETE") {
        data.profilePictureId = null;
      }

      if (this.cover.status == "CHANGE") {
        const coverUploadData = {
          path: "card_cover_image",
          file: this.cover,
        };
        const uploadedCoverMedia = await uploadMediaToS3(coverUploadData);
        this.cover.status = null;
        data.coverId = uploadedCoverMedia.id;
      } else if (this.cover.status == "DELETE") {
        data.coverId = null;
      }
      delete data.url;
      return this.$mutate(upsert, {
        id: Number(id),
        input: {
          ...data,
        },
      }).then(({ data }) => {
        return data;
      });
    },
  },
};
</script>
